import React from 'react';
import { observer } from 'mobx-react';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import Congrats from '../Congrats';
import NoDiscount from './NoDiscount';

const NoPhoneWelcomeGift: React.FC = () => {
  const content = React.useMemo(() => {
    switch (true) {
      case DiscountsStore.isWelcomeGiftDiscountValid:
        return <Congrats />;
      default:
        return <NoDiscount />;
    }
  }, [DiscountsStore.isWelcomeGiftDiscountValid]);

  return content;
};

export default observer(NoPhoneWelcomeGift);
